export const pubs = [
 {
   "title": "An electrical artifact associated with the ERG-jet gold foil electrode.",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach GL",
   "author2": "Purple RL",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/?term=An+electrical+artifact+associated+with+the+ERG-jet+gold+foil+electrode#",
   "image": "",
   "notes": ""
 },
 {
   "title": "Polymer conjugation reduces deferoxamine induced retinopathy in an albino rat model.",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach GL",
   "author2": "Purple RL",
   "author3": "Schultz LM",
   "moreAuthors": true,
   "date": 1993,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/7689545",
   "image": "",
   "notes": ""
 },
 {
   "title": "Enhancement of retinal recovery by conjugated deferoxamine after ischemia-reperfusion.",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach GL",
   "author2": "Purple RL",
   "author3": "",
   "moreAuthors": false,
   "date": 1994,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/7509327",
   "image": "",
   "notes": ""
 },
 {
   "title": "A paired comparison of the vascular ligation and increased intraocular pressure models of retinal ischemia. ",
   "publication": "Curr Eye Res ",
   "author1": "Gehlbach GL",
   "author2": "Purple RL",
   "author3": "",
   "moreAuthors": false,
   "date": 1994,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/7956312",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retinal detachment associated with subthreshold retinopathy of prematurity. ",
   "publication": "Journal of Pediatric Ophthalmology and Strabismus",
   "author1": "Gurdian SJ",
   "author2": "Gehlbach PL",
   "author3": "Robertson JE",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/7956312",
   "image": "",
   "notes": ""
 },
 {
   "title": "Inhibition of choroidal neovascularization by intravenous injection of adenoviral vectors expressing secretable endostatin.",
   "publication": "The American Journal of Pathology ",
   "author1": "Mori K",
   "author2": "Ando A",
   "author3": "Gehlbach GL",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1850426/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pigment epithelium-derived factor inhibits retinal and choroidal neovascularization.",
   "publication": "Journal of Cellular Physiology",
   "author1": "Mori K",
   "author2": "Gehlbach GL",
   "author3": "Campochiaro PA",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11424092",
   "image": "",
   "notes": ""
 },
 {
   "title": "Inducible expression of VEGF in adult mice causes severe proliferative retinopathy and retinal detachment.",
   "publication": "The American Journal of Pathology ",
   "author1": "Ohno-Matsui K",
   "author2": "Gehlbach GL",
   "author3": "Campochiaro PA",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1850637/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pigment epithelium-derived factor (PEDF) suppresses ischemia-induced retinal  neovascularization and VEGF-induced migration and growth",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Duh E",
   "author2": "Yang H",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11867604",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular adenoviral vector-mediated gene transfer is increased in proliferative retinopathies",
   "publication": "Investigative Ophthalmology & Visual Science ",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Ando A",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11980881",
   "image": "",
   "notes": ""
 },
 {
   "title": "AAV-mediated gene transfer of pigment epithelium-derived factor inhibits choroidal neovascularization.",
   "publication": "Investigative Ophthalmology & Visual Science ",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Yamamoto S",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12037010",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retina-specific expression of PDGF-B versus PDGF-A: vascular versus nonvascular proliferative retinopathy.",
   "publication": "Investigative Ophthalmology & Visual Science ",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Ando A",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12037011",
   "image": "",
   "notes": ""
 },
 {
   "title": "The ultra-late phase of indocyanine green angiography for healthy subjects and patients with age-related macular degeneration",
   "publication": "Retina ",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Nishiyama Y",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12055464",
   "image": "",
   "notes": ""
 },
 {
   "title": "Regression of ocular neovascularization in response to increased expression of pigment epithelium-derived factor",
   "publication": "Investigative Ophthalmology & Visual Science ",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Ando A",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12091447",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular gene transfer of sFlt-1 suppresses ocular neovascularization and vascular endothelial growth factor-induced breakdown of the blood-retinal barrier",
   "publication": "Human Gene Therapyapy",
   "author1": "Gehlbach PL",
   "author2": "Demetriades AM",
   "author3": "Campochiaro PA",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12614564",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular injection of an adenoviral vector encoding of pigment epithelium-derived factor inhibits choroidal neovascularization",
   "publication": "Gene Therapy",
   "author1": "Gehlbach PL",
   "author2": "Demetriades AM",
   "author3": "Campochiaro PA",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.nature.com/articles/3301931",
   "image": "",
   "notes": ""
 },
 {
   "title": "Increased expression of brain-derived neurotrophic factor preserves retinal function and slows cell death from rhodopsin mutation or oxidative damage",
   "publication": "Journal of Neuroscience",
   "author1": "Okoye G",
   "author2": "Zimmer J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12764104",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular gene transfer of pigment epithelium-derive factor protects the retina from ischemic injury by reducing retinal cell apoptosis",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Takita H",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.researchgate.net/publication/8394493_Intraocular_gene_transfer_of_pigment_epithelium-derived_factor_rescues_photoreceptors_from_light-induced_cell_death",
   "image": "",
   "notes": ""
 },
 {
   "title": "A comparison of epiretinal membranes, of differing pathogenesis, using optical coherence tomography",
   "publication": "Retina",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Yoneya S",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15076945",
   "image": "",
   "notes": ""
 },
 {
   "title": "Asymmetry of choroidal venous vascular patterns in the human eye",
   "publication": "Ophthalmology",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Shimizu K",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15019327",
   "image": "",
   "notes": ""
 },
 {
   "title": "Vitreous levels of pigment epithelium-derived factor (PEDF) and vascular endothelial growth factor (VEGF): implications for ocular angiogenesis",
   "publication": "American Journal of Ophthalmology",
   "author1": "Duh EJ",
   "author2": "Ying HS",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15059706",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular gene transfer of pigment epithelium-derived factor rescues photoreceptors from light-induced cell death",
   "publication": "Journal of Cellular Physiology",
   "author1": "Imai D",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15316929",
   "image": "",
   "notes": ""
 },
 {
   "title": "Decreased arterial dye-filling and venous dilation in the macular choroid associated with age-related macular degeneration",
   "publication": "Retina",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Yoneya S",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15933588",
   "image": "",
   "notes": ""
 },
 {
   "title": "Advanced glycation endproduct-induced aging of the retinal pigment epithelium and choroid: a comprehensive transcriptional response",
   "publication": "Proceedings of the National Academy of Sciences USA",
   "author1": "Tian J",
   "author2": "Ishibashi K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16081535",
   "image": "",
   "notes": ""
 },
 {
   "title": "Laser therapy targets and enhances adenovirus vector mediated gene transfer in the rat retina",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Anzai K",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16186378",
   "image": "",
   "notes": ""
 },
 {
   "title": "A potential role for γ- and β-crystallins in vascular remodeling of the eye",
   "publication": "Developmental Dynamics",
   "author1": "Zhang C",
   "author2": "Gehlbach PL",
   "author3": "Gongora C",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16003775",
   "image": "",
   "notes": ""
 },
 {
   "title": "Developmental abnormalities in the Nuc1 rat retina: a spontaneous mutation that affects neuronal and vascular remodeling and retinal function",
   "publication": "Neuroscience",
   "author1": "Gehlbach PL",
   "author2": "Hose S",
   "author3": "Zhang C",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16289888",
   "image": "",
   "notes": ""
 },
 {
   "title": "Optical coherence tomography of peripheral retinal lesions in enucleated human eye specimens with histological correlation",
   "publication": "American Journal of Ophthalmology",
   "author1": "Ghazi NG",
   "author2": "Dibernardo C",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16564813",
   "image": "",
   "notes": ""
 },
 {
   "title": "Optical coherence tomography of enucleated human eye specimens with histological correlation: origin of the outer \"red line\"",
   "publication": "American Journal of Ophthalmology",
   "author1": "Ghazi NG",
   "author2": "Dibernardo C",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16564808",
   "image": "",
   "notes": ""
 },
 {
   "title": "Transpupillary thermAbstractapy-induced modification of angiogenesis- and coagulation-related gene expression in the rat posterior fundus",
   "publication": "Molecular Vision",
   "author1": "Ito YN",
   "author2": "Ito M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16885923",
   "image": "",
   "notes": ""
 },
 {
   "title": "Human amniotic fluid in the treatment of acute ocular alkali burns",
   "publication": "American Journal of Ophthalmology",
   "author1": "Herretes S",
   "author2": "Olan Suwan-apichon O",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16876508",
   "image": "",
   "notes": ""
 },
 {
   "title": "Treatment of stage 2 macular hole by intravitreous injection of expansile gas and induction of posterior vitreous detachment",
   "publication": "Ophthalmology",
   "author1": "Mori K",
   "author2": "Saito S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/17070585",
   "image": "",
   "notes": ""
 },
 {
   "title": "Imaging mitochondria in living corneal endothelial cells using autofluorescence microscopy",
   "publication": "Photochemistry Photobiology",
   "author1": "Ramey NA",
   "author2": "Park CY",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18028205",
   "image": "",
   "notes": ""
 },
 {
   "title": "Choroidal perfusion delay and hyperpermeability in exudative retinal detachment induced by panretinal scatter photocoagulation",
   "publication": "Retinal Cases & Brief Reports",
   "author1": "Mori K",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25390478",
   "image": "",
   "notes": ""
 },
 {
   "title": "Association of the HTRA1 gene variant with age-related macular degeneration in the Japanese population",
   "publication": "Journal of Human Genetics",
   "author1": "Mori K",
   "author2": "Horie K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/17568988",
   "image": "",
   "notes": ""
 },
 {
   "title": "Coding and noncoding variants in the CFH gene and cigarette smoking influence the risk of age-related macular degeneration in a Japanese population",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Kabasawa S",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/17962488",
   "image": "",
   "notes": ""
 },
 {
   "title": "Lacrimal gland inflammatory cytokine gene expression in the botulinum toxin b-induced murine dry eye model",
   "publication": "Molecular Vision",
   "author1": "Park CY",
   "author2": "Zhuang W",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18087241",
   "image": "",
   "notes": ""
 },
 {
   "title": "Trans-scleral delivery of antiangiogenic proteins",
   "publication": "Journal of Ocular Pharmacology and Therapeutics",
   "author1": "Demetriades AM",
   "author2": "Deering T",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18370877",
   "image": "",
   "notes": ""
 },
 {
   "title": "Accidental nd:YAG laser-induced choroidal neovascularization",
   "publication": "Lasers in Surgery and Medicine",
   "author1": "Ying HS",
   "author2": "Symons RCA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18412221",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular triamcinolone enhances  intraocular gene expression following delivery by adenovirus",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Park CY",
   "author2": "Chuck RS",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18172118",
   "image": "",
   "notes": ""
 },
 {
   "title": "Corneal reepithelization is modulated by topical application of amniotic fluid in an ex-vivo organ culture model",
   "publication": "Experimental Eye Research",
   "author1": "Castro-Combs J",
   "author2": "Noguera G",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18555991",
   "image": "",
   "notes": ""
 },
 {
   "title": "Demonstration by redox fluorometry that sulforaphane protects retinal pigment epithelial cells against oxidative stress",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Cano M",
   "author2": "Reyes J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18515589",
   "image": "",
   "notes": ""
 },
 {
   "title": "An Empty E1-, E3-, E4- Adenoviral vector protects photoreceptors from light-induced degeneration",
   "publication": "Journal of Ocular Biology, Diseases, and Informatics",
   "author1": "Takita H",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20072633",
   "image": "",
   "notes": ""
 },
 {
   "title": "PPAR-α Ligands as Potential Therapeutic Agents for Wet Age-Related Macular Degeneration",
   "publication": "PPAR Research",
   "author1": "Cano M",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18401454",
   "image": "",
   "notes": ""
 },
 {
   "title": "Persistent expression of pedf  in the eye using high-capacity adenovectors",
   "publication": "Molecular Therapy",
   "author1": "Chen P",
   "author2": "Hamilton M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18827806",
   "image": "",
   "notes": ""
 },
 {
   "title": "A peptide derived from type 1 thrombospondin repeat-containing protein wisp-1 inhibits corneal and choroidal neovascularization",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Cano M",
   "author2": "Karagiannis ED",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/19279315",
   "image": "",
   "notes": ""
 },
 {
   "title": "Immunosuppressive property of dried human amniotic membrane",
   "publication": "Ophthalmic Research",
   "author1": "Park CY",
   "author2": "Kohanim S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/19122474",
   "image": "",
   "notes": ""
 },
 {
   "title": "The effect of phacoemulsification energy on the redox state of cultured human corneal endothelial cells",
   "publication": "Archives of Ophthalmology",
   "author1": "Shin YJ",
   "author2": "Nishi Y",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/19365020",
   "image": "",
   "notes": ""
 },
 {
   "title": "A sub-millimetric, 0.25 mN resolution fully integrated fiber-optic force-sensing tool for retinal microsurgery",
   "publication": "International Journal of Computer Assisted Radiology and Surgery",
   "author1": "Iordachita I",
   "author2": "Sun Z",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20033585",
   "image": "",
   "notes": ""
 },
 {
   "title": "A Sub-Millemetric, 0.25 mN Resolution Fully Integrated Fiber-Optic Force Sensing Tool for Retinal Microsurgery",
   "publication": "International Journal of Computer Assisted Radiology and Surgery",
   "author1": "Sun Z",
   "author2": "Balicki M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2801926/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Statins for age-related macular degeneration",
   "publication": "The Cochrane Database of Systematic Reviews",
   "author1": "Gehlbach PL",
   "author2": "Li T",
   "author3": "Hatef E",
   "moreAuthors": false,
   "date": 2009,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/27490232",
   "image": "",
   "notes": ""
 },
 {
   "title": "Single fiber optical  coherence tomography microsurgical instruments for computer and robot-assisted retinal surgery",
   "publication": "Medical Image Computing and Computer-Assisted Intervention",
   "author1": "Balicki M",
   "author2": "Taylor R",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-04268-3_14",
   "image": "",
   "notes": "Best CAI Paper Award"
 },
 {
   "title": "Micro-force sensing in robot assisted membrane peeling for vitreoretinal surgery",
   "publication": "Medical Image Computing and Computer-Assisted Intervention",
   "author1": "Balicki M",
   "author2": "Uneri A",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20879413",
   "image": "",
   "notes": "Runner-up for best medical robotics paper"
 },
 {
   "title": "The role of indoleamine 2, 3 dioxygenase in retinal pigment epithelial cell mediated immune modulation",
   "publication": "Ocular Immunology and Inflammation",
   "author1": "Park CY",
   "author2": "Yang SH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20128646",
   "image": "",
   "notes": ""
 },
 {
   "title": "Phenotype and genotype characteristics of age-related macular degeneration in a Japanese population",
   "publication": "Ophthalmology",
   "author1": "Mori K",
   "author2": "Horie-Inoue K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20132989",
   "image": "",
   "notes": ""
 },
 {
   "title": "Apolipoprotein b100 secretion by cultured arpe-19 cells is modulated by alteration of cholesterol levels",
   "publication": "Journal of Neurochemistry",
   "author1": "Wu T",
   "author2": "Fujihara M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20598021",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fluorometric determination of the redox state and distribution of mitochondria in human malignant glioblastoma cells grown on different culturing substrates",
   "publication": "Photomedicine and Laser Surgery",
   "author1": "Shin YJ",
   "author2": "Tata DB",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20666574",
   "image": "",
   "notes": ""
 },
 {
   "title": "Adaptive multispectral illumination for retinal microsurgery",
   "publication": "Medical Image Computing and Computer-Assisted Intervention",
   "author1": "Sznitman R",
   "author2": "Rother D",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-15711-0_58",
   "image": "",
   "notes": ""
 },
 {
   "title": "Complement factor h and high-temperature requirement a-1 genotypes and treatment response of age-related macular degeneration",
   "publication": "Ophthalmology",
   "author1": "Tsuchihashi T",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20678803",
   "image": "",
   "notes": ""
 },
 {
   "title": "Endoscopic functional fourier domain common path optical coherence tomography for microsurgery",
   "publication": "IEEE Journal of Selected Topics in Quantum Electronics",
   "author1": "Kang JU",
   "author2": "Han J-H",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Original Research",
   "link": "http://ieeexplore.ieee.org/document/5291734/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Permanent keratoprosthesis combined with pars plana vitrectomy and silicone oil injection for visual rehabilitation of chronic hypotony and corneal opacity",
   "publication": "Cornea",
   "author1": "Utine CA",
   "author2": "Gehlbach PL",
   "author3": "Zimmer-Galler I",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/20847680",
   "image": "",
   "notes": ""
 },
 {
   "title": "New steady-hand eye robot with micro-force sensing for vitreoretinal surgery",
   "publication": "IEEE RAS & EMBS International Conference on Biomedical Robotics and Biomechatronics",
   "author1": "Uneri A",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3065995/",
   "image": "",
   "notes": ""
 },
 {
   "title": "CFH, VEGF, and PEDF genotypes and the response to intravitreous injection of bevacizumab for the treatment of age-related macular degeneration",
   "publication": "Journal of Ocular Biology, Diseases, and Informatics",
   "author1": "Imai D",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/21811649",
   "image": "",
   "notes": ""
 },
 {
   "title": "Unified detection and tracking in retinal microsurgery",
   "publication": "Medical Image Computing and Computer-Assisted Intervention",
   "author1": "Sznitman R",
   "author2": "Basu A",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Original Research",
   "link": "http://ieeexplore.ieee.org/document/6319313/",
   "image": "",
   "notes": "Runner-up for best paper in medical robotics and CAI systems"
 },
 {
   "title": "Associations of cigarette smoking but not serum fatty acids with age-related macular degeneration in a Japanese population",
   "publication": "Ophthalmology",
   "author1": "Kabasawa S",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/21514959",
   "image": "",
   "notes": ""
 },
 {
   "title": "Safety, tolerability, and bioavailability of topical SAR 1118, a novel antagonist of lymphocyte function-associated antigen-1: a phase 1b study",
   "publication": "Eye",
   "author1": "Paskowitz DM",
   "author2": "Nguyen QD",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/22538219",
   "image": "",
   "notes": ""
 },
 {
   "title": "Real-time three-dimensional Fourier-domain optical coherence tomography video image guided microsurgeries",
   "publication": "Journal of Biomedical Optics",
   "author1": "Kang JU",
   "author2": "Huang Y",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/23224164",
   "image": "",
   "notes": ""
 },
 {
   "title": "Chronic hypotony associated with Boston type I keratoprosthesis",
   "publication": "American Journal of Ophthalmology",
   "author1": "Dokey A",
   "author2": "Ramulu PY",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/22633347",
   "image": "",
   "notes": ""
 },
 {
   "title": "Statins for age-related macular degeneration",
   "publication": "The Cochrane Database of Systematic Reviews",
   "author1": "Gehlbach PL",
   "author2": "Li T",
   "author3": "Hatef E",
   "moreAuthors": false,
   "date": 2012,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/27490232",
   "image": "",
   "notes": ""
 },
 {
   "title": "A force-sensing microsurgical instrument that detects forces below human tactile sensation",
   "publication": "Retina",
   "author1": "Sunshine S",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/22810149",
   "image": "",
   "notes": ""
 },
 {
   "title": "Evaluation of a micro-force sensing handheld robot for vitreoretinal surgery",
   "publication": "Proceedings of the IEEE/RSJ International Conference on Intelligent Robots and Systems",
   "author1": "Gonenc B",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3559009/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Auditory force feedback substitution improves surgical precision during simulated ophthalmic surgery",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Cutler N",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/23329663",
   "image": "",
   "notes": ""
 },
 {
   "title": "Viral transgene expression delivered by repeat intraocular adenoviral vector injection: in vivo live imaging study",
   "publication": "Molecular Imaging",
   "author1": "Gehlbach PL",
   "author2": "Chuck RS",
   "author3": "Park CG",
   "moreAuthors": true,
   "date": 2012,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/22954180",
   "image": "",
   "notes": ""
 },
 {
   "title": "Montage images of spectral-domain optical coherence tomography in eyes with idiopathic macular holes",
   "publication": "Ophthalmology",
   "author1": "Mori K",
   "author2": "Kanno J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/22892150",
   "image": "",
   "notes": ""
 },
 {
   "title": "Active tremor cancellation by a \"smart\" handheld vitreoretinal microsurgical tool using swept source optical coherence tomography",
   "publication": "Optics Express",
   "author1": "Song C",
   "author2": "Gehlbach PL",
   "author3": "Kang JU",
   "moreAuthors": false,
   "date": 2012,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3601638/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ball lens fiber optic sensor based smart handheld microsurgical instrument",
   "publication": "Proceedings of SPIE",
   "author1": "Song C",
   "author2": "Gehlbach PL",
   "author3": "Kang JU",
   "moreAuthors": false,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3820282/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Long-term outcomes in ranibizumab-treated patients with retinal vein occlusion: the role of progression of retinal nonperfusion",
   "publication": "American Journal of Ophthalmology",
   "author1": "Sophie R",
   "author2": "Hafiz G",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4030598/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber-optic OCT sensor guided “SMART” micro-forceps for microsurgery",
   "publication": "Biomedical Optics Express",
   "author1": "Song C",
   "author2": "Park DY",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3704086/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Design of 3-DOF force sensing micro-forceps for robot assisted vitreoretinal surgery",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "Gonenc B",
   "author2": "Handa J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/24111028",
   "image": "",
   "notes": ""
 },
 {
   "title": "Freehand OCT with real-time lateral motion tracking",
   "publication": "Progress in Biomedical Optics and Imaging - SPIE",
   "author1": "Liu X",
   "author2": "Yong H",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.spiedigitallibrary.org/conference-proceedings-of-spie/8571/1/Freehand-OCT-with-real-time-lateral-motion-tracking/10.1117/12.2006973.short?SSO=1",
   "image": "",
   "notes": ""
 },
 {
   "title": "Interactive OCT annotation and visualization for vitreoretinal surgery",
   "publication": "Augmented Environments for Computer-Assisted Interventions. Lecture Notes in Computer Science",
   "author1": "Balicki M",
   "author2": "Richa R",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-38085-3_14",
   "image": "",
   "notes": ""
 },
 {
   "title": "Comparison of baseline tremor under various microsurgical conditions",
   "publication": "IEEE International Conference on Systems, Man, and Cybernetics",
   "author1": "Wells TS",
   "author2": "Yang S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3989364/",
   "image": "",
   "notes": ""
 },
 {
   "title": "A comparative study for robot assisted vitreoretinal surgery: micron vs. the steady-hand robot",
   "publication": "IEEE International Conference on Robotics and Automation",
   "author1": "Gonenc B",
   "author2": "Handa J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3971925/",
   "image": "",
   "notes": ""
 },
 {
   "title": "A novel dual force sensing instrument with cooperative robotic assistant for vitreoretinal surgery",
   "publication": "IEEE International Conference on Robotics and Automation",
   "author1": "He X",
   "author2": "Balicki M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/24795831",
   "image": "",
   "notes": ""
 },
 {
   "title": "A sub-millimetric 3-DOF force sensing instrument with integrated fiber Bragg grating for retinal microsurgery",
   "publication": "IEEE Trans Biomed Eng",
   "author1": "He X",
   "author2": "Balicki M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "",
   "link": "http://ieeexplore.ieee.org/document/6609063/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Towards robot-assisted vitreoretinal surgery: Force-sensing micro-forceps integrated with a handheld micromanipulator",
   "publication": "IEEE International Conference on Robotics and Automation",
   "author1": "Gonenc B",
   "author2": "Feldman E",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4228486/",
   "image": "",
   "notes": ""
 },
 {
   "title": "A multi-function force sensing instrument for variable admittance robot control in retinal microsurgery",
   "publication": "IEEE International Conference on Robotics and Automation",
   "author1": "He X",
   "author2": "Balicki M",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "http://ieeexplore.ieee.org/abstract/document/6907037/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ocular localization and transduction by adenoviral vectors and serotype-dependent and can be modified by inclusion of RGD fiber modifications",
   "publication": "PLOS One",
   "author1": "Ueyama K",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25232844",
   "image": "",
   "notes": ""
 },
 {
   "title": "Motorized force-sensing micro-forceps with tremor cancelling and controlled micro-vibrations for easier membrane peeling",
   "publication": "IEEE RAS & EMBS International Conference on Biomedical Robotics and Biomechatronics",
   "author1": "Gonenc B",
   "author2": "Gehlbach PL",
   "author3": "Handa J",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4276332/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Development of a miniaturized 3-DOF force sensing instrument for robotically assisted retinal microsurgery and preliminary results",
   "publication": "IEEE RAS & EMBS International Conference on Biomedical Robotics and Biomechatronics",
   "author1": "He X",
   "author2": "Gehlbach PL",
   "author3": "Handa J",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25544966",
   "image": "",
   "notes": ""
 },
 {
   "title": "Predictors of visual outcomes following Boston type 1 keratoprosthesis implantation",
   "publication": "American Journal of Ophthalmology",
   "author1": "Ahmad S",
   "author2": "Akpek EK",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25555801",
   "image": "",
   "notes": ""
 },
 {
   "title": "Injection-depth-locking axial motion guided handheld micro-injector using CP-SSOCT",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "Gyeong WC",
   "author2": "Yong H",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25571404",
   "image": "",
   "notes": ""
 },
 {
   "title": "Toward robotically assisted membrane peeling with 3-DOF distal force sensing in retinal microsurgery",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society. Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "He X",
   "author2": "Gehlbach PL",
   "author3": "Handa J",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25571572",
   "image": "",
   "notes": ""
 },
 {
   "title": "Human eye phantom for developing computer and robot-assisted epiretinal membrane peeling",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "Gupta A",
   "author2": "Gonenc B",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4288026/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Force-sensing microneedle for assisted retinal vein cannulation",
   "publication": "Proceedings of IEEE Sensors",
   "author1": "Gonenc B",
   "author2": "Gehlbach PL",
   "author3": "Handa J",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4288008/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Statins for age-related macular degeneration",
   "publication": "The Cochrane Database of Systematic Reviews",
   "author1": "Gehlbach PL",
   "author2": "Li T",
   "author3": "Hatef E",
   "moreAuthors": false,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/27490232",
   "image": "",
   "notes": ""
 },
 {
   "title": "Accurate real-time depth control for CP-SSOCT distal sensor based handheld microsurgery tools",
   "publication": "Biomedical Optics Express",
   "author1": "Cheon GW",
   "author2": "Huang Y",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26137393",
   "image": "",
   "notes": ""
 },
 {
   "title": "Posterior Vitreous Mobility Delineated by Tracking of Optical Coherence Tomography Images in Eyes with Idiopathic Macular Holes",
   "publication": "American Journal of Ophthalmology",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Kishi S",
   "moreAuthors": false,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25743339",
   "image": "",
   "notes": ""
 },
 {
   "title": "Outcomes Associated With Concurrent Iris-Sutured Intraocular Lens Placement and Subluxated Crystalline Lens Extraction",
   "publication": "JAMA Ophthalmology",
   "author1": "McClellan SF",
   "author2": "Soiberman U",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/25974186",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pars plana vitrectomy and iris suture fixation of posteriorly dislocated intraocular lenses",
   "publication": "Journal of Cataract & Refractive Surgery",
   "author1": "Soiberman U",
   "author2": "Gehlbach PL",
   "author3": "Murakami P",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26287884",
   "image": "",
   "notes": ""
 },
 {
   "title": "Inhibition of Corneal Neovascularization by Subconjunctival Injection of Fc-endostatin, a Novel Inhibitor of Angiogenesis",
   "publication": "Journal of Ophthalmology, Special Issue on Angiogenesis",
   "author1": "Yoshida J",
   "author2": "Wicks R",
   "author3": " Zambrano A",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26491546",
   "image": "",
   "notes": ""
 },
 {
   "title": "IRIS: Integrated Robotic Intraocular Snake",
   "publication": "IEEE International Conference on Robotics and Automation",
   "author1": "He X",
   "author2": "van Geirt V",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26405561",
   "image": "",
   "notes": ""
 },
 {
   "title": "FBG-based sensorized light pipe for robotic intraocular illumination facilitates bimanual retinal microsurgery",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "Horise Y",
   "author2": "Xingchi He",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26736189",
   "image": "",
   "notes": ""
 },
 {
   "title": "Development of the dual SMART micro-surgical system using common-path swept source optical coherence tomography",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "Park HC",
   "author2": "Yeo CB",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26736187",
   "image": "",
   "notes": ""
 },
 {
   "title": "Interventions for central serous chorioretinopathy: a network meta-analysis",
   "publication": "The Cochrane Database of Systematic Reviews",
   "author1": "Salehi M",
   "author2": "Wenick AS",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26691378",
   "image": "",
   "notes": ""
 },
 {
   "title": "Effects of Micro-Vibratory Modulation during Robot-Assisted Membrane Peeling",
   "publication": "IROS, Proceedings of the IEEE/RSJ International Conference on Intelligent Robots and Systems",
   "author1": "Gonenc B",
   "author2": "Gehlbach PL",
   "author3": " Taylor R",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4838409/",
   "image": "",
   "notes": ""
 },
 {
   "title": " Force-Based Puncture Detection and Active Position Holding for Assisted Retinal Vein Cannulation",
   "publication": "IEEE SICE RSJ International Conference on Multisensor Fusion and Integration for Intelligent Systems",
   "author1": "Gonenc B",
   "author2": "Tran N",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/27127804",
   "image": "",
   "notes": "Best Paper Award Nominee"
 },
 {
   "title": "Retinochoroidal Morphology Described by Wide-Field Montage Imagining of Spectral Domain-Optical Coherence Tomography",
   "publication": "Retina",
   "author1": "Mori K",
   "author2": "Kanno J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4747978/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Statins for age-related macular degeneration",
   "publication": "The Cochrane Database of Systematic Reviews",
   "author1": "Gehlbach PL",
   "author2": "Li T",
   "author3": "Hatef E",
   "moreAuthors": false,
   "date": 2016,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/27490232",
   "image": "",
   "notes": ""
 },
 {
   "title": "Dual Optical Coherence Tomography Sensor Guided, Two-motor, Horizontal SMART Micro-scissors",
   "publication": "OSA Optics Letters",
   "author1": "Yeo C",
   "author2": "Park HC",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/28005877",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ghost reduction in CP-SSOCT having multiple references using Fourier-domain Shift and Sum",
   "publication": "IEEE Photonics Technology Letters",
   "author1": "Cheon GW",
   "author2": "Gehlbach PL",
   "author3": "Kang JU",
   "moreAuthors": false,
   "date": 2016,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/28042225",
   "image": "",
   "notes": ""
 },
 {
   "title": "Development and preliminary results of bimanual smart micro-surgical system using a ball-lens coupled OCT distance sensor",
   "publication": "Biomed Optics Express",
   "author1": "Koo D",
   "author2": "Park HC",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5119618/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Robot-assisted retinal vein cannulation with force-based puncture detection: Micron vs. the steady-hand eye robot",
   "publication": "Proceedings of the IEEE Engineering in Medicine and Biology Society",
   "author1": "Gonenc B",
   "author2": " Tran N",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/28269417",
   "image": "",
   "notes": ""
 },
 {
   "title": "The Role of Iron in Ischemia/Reperfusion Injury in the Cat Retina",
   "publication": "Doctoral Dissertation, The University of Minnesota, Minneapolis, MN. TC Bio-Medical Library General Collection",
   "author1": "Gehlbach PL",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 1995,
   "category": "Basic",
   "type": "Original Research",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Revised indications for the treatment of retinopathy of prematurity: results of the early treatment for retinopathy of prematurity randomized trial",
   "publication": "Archives of Ophthalmology",
   "author1": "Early Treatment For Retinopathy Of Prematurity Cooperative Group",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2003,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/14662586",
   "image": "",
   "notes": "FALSE"
 },
 {
   "title": "Risk analysis of prethreshold retinopathy of prematurity",
   "publication": "Archives of Ophthalmology",
   "author1": "Hardy RJ",
   "author2": "Palmer EA",
   "author3": "Dobson V",
   "moreAuthors": true,
   "date": 2003,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/14662587",
   "image": "",
   "notes": "FALSE"
 },
 {
   "title": "Vitrase: Intravitreal hyaluronidase for non-clearing vitreous hemorrhage. Hyaluronidase (Vitrase)—ISTA: hyaluronidase—ISTA pharmaceuticals",
   "publication": "Drugs in R&D",
   "author1": "NA",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2003,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12757408",
   "image": "",
   "notes": "FALSE"
 },
 {
   "title": "Reduction of Macular Edema by Oral Administration of the Kinase Inhibitor PKC412",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Campochiaro PA",
   "author2": "C99-PKC412-003 Study Group",
   "author3": "",
   "moreAuthors": false,
   "date": 2004,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/14985312",
   "image": "",
   "notes": "FALSE"
 },
 {
   "title": "Supplemental oxygen improves diabetic macular edema: a pilot study",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Nguyen QD",
   "author2": "Shah SM",
   "author3": "Van Anden E",
   "moreAuthors": true,
   "date": 2004,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/14744906",
   "image": "",
   "notes": "FALSE"
 },
 {
   "title": "The Diabetic Retinopathy Clinical Research Network. Comparison of the modified Early Treatment Diabetic Retinopathy Study and mild macular grid laser photocoagulation strategies for diabetic macular edema",
   "publication": "Archives of Ophthalmology",
   "author1": "NA",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2007,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/17420366",
   "image": "",
   "notes": "FALSE"
 },
 {
   "title": "SCORE Study Research Group. A randomized trial comparing the efficacy and safety of intravitreal triamcinolone with standard care to treat vision loss associated with macular Edema secondary to branch retinal vein occlusion: the Standard Care vs Corticosteroid for Retinal Vein Occlusion (SCORE) study report 6",
   "publication": "Archives of Ophthalmology",
   "author1": "Scott IU",
   "author2": "Ip MS",
   "author3": "VanVeldhuisen PC",
   "moreAuthors": false,
   "date": 2009,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/19752420",
   "image": "",
   "notes": "TRUE"
 },
 {
   "title": "SCORE Study Investigator Group. SCORE Study Report 7: incidence of intravitreal silicone oil droplets associated with staked-on vs luer cone syringe design",
   "publication": "American Journal of Ophthalmology",
   "author1": "Scott IU",
   "author2": "Oden NL",
   "author3": "VanVeldhuisen PC",
   "moreAuthors": true,
   "date": 2009,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/19674727",
   "image": "",
   "notes": "TRUE"
 },
 {
   "title": "SCORE Study Research Group. A randomized trial comparing the efficacy and safety of intravitreal triamcinolone with observation to treat vision loss associated with macular edema secondary to central retinal vein occlusion: the Standard Care vs Corticosteroid for Retinal Vein Occlusion (SCORE) study report 5",
   "publication": "Archives of Ophthalmology",
   "author1": "Ip MS",
   "author2": "Scott IU",
   "author3": "VanVeldhuisen PC",
   "moreAuthors": true,
   "date": 2009,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/19752419",
   "image": "",
   "notes": ""
 },
 {
   "title": "Dexamethasone intravitreal implant in patients with macular edema related to branch or central retinal vein occlusion twelve-month study results.",
   "publication": "Ophthalmology",
   "author1": "Haller JA",
   "author2": "Bandello F",
   "author3": "Belfort R Jr",
   "moreAuthors": true,
   "date": 2011,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "http://www.ncbi.nlm.nih.gov/pubmed/21764136",
   "image": "",
   "notes": "TRUE"
 },
 {
   "title": "Incidence, Risk Factors, and Timing of Elevated Intraocular Pressure After Intravitreal Triamcinolone Acetonide Injection for Macular Edema Secondary to Retinal Vein Occlusion: SCORE Study Report 15",
   "publication": "JAMA Ophthalmology",
   "author1": "Aref AA",
   "author2": "Scott IU",
   "author3": "Oden NL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "http://www.ncbi.nlm.nih.gov/pubmed/26086920",
   "image": "",
   "notes": "TRUE"
 },
 {
   "title": "Relationship between optical coherence tomography–measured central retinal thickness and visual acuity in diabetic macular edema",
   "publication": "Diabetic Retinopathy Clinical Research Network",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2007,
   "category": "Clinical",
   "type": "Clinical Trial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/17123615",
   "image": "",
   "notes": "TRUE"
 },
 {
   "title": "Acute choroidal infarction following subcutaneous injection of micronized dermal matrix in the forehead region",
   "publication": "Retina",
   "author1": "Apte RS",
   "author2": "Solomon SS",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 2003,
   "category": "Clinical",
   "type": "Case Report",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/12972773",
   "image": "",
   "notes": ""
 },
 {
   "title": "Severe proliferative retinopathy in a patient with Duchenne muscular dystrophy",
   "publication": "British Journal of Ophthalmology",
   "author1": "Louie K",
   "author2": "Apte R",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 2004,
   "category": "Clinical",
   "type": "Case Report",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15548827",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retinal metastasis in a patient with adenocarcinoma of the cecum",
   "publication": "Archives of Ophthalmology",
   "author1": "Apte RS",
   "author2": "DiBernardo C",
   "author3": "Pearlman JR",
   "moreAuthors": true,
   "date": 2005,
   "category": "Clinical",
   "type": "Case Report",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/15955988",
   "image": "",
   "notes": ""
 },
 {
   "title": "Acute Ophthalmic Artery Occlusion As Initial Manifestation of Acquired Immune Deficiency Syndrome",
   "publication": "Int J Ophthalmol Clin Res",
   "author1": "Gowtham J",
   "author2": "Katz MSJ",
   "author3": "Rubaltelli DM",
   "moreAuthors": true,
   "date": 2015,
   "category": "Clinical",
   "type": "Case Report",
   "link": "https://www.researchgate.net/publication/281391929_Acute_Ophthalmic_Artery_Occlusion_as_Initial_Manifestation_of_Acquired_Immunodeficiency_Syndrome",
   "image": "",
   "notes": ""
 },
 {
   "title": "Diffuse Unilateral Subacute Neuroretinitis (DUSN)",
   "publication": "Current Ocular Therapy, 5th Ed, Fraunfelder, Roy (eds.)",
   "author1": "Gehlbach PL",
   "author2": "Robertson JR",
   "author3": "",
   "moreAuthors": false,
   "date": 1999,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular Foreign Body-nonmagnetic, Chemically Inert",
   "publication": "Current Ocular Therapy, 5th Ed, Fraunfelder, Roy (eds.)",
   "author1": "Gehlbach PL",
   "author2": "Robertson JR",
   "author3": "",
   "moreAuthors": false,
   "date": 1999,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Antiangiogenic Gene Therapy: Prospects for Human Application",
   "publication": "Vitreoretinal Surgical Techniques, 2nd Ed, Peyman, Meffert, Chou, Conway (eds.)",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2006,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular Foreign Body-nonmagnetic, Chemically Inert",
   "publication": "Current Ocular Therapy, 6th Ed, Fraunfelder, Roy (eds.)",
   "author1": "Ying H",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2006,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "ICG Angiography Basics and Principles",
   "publication": "Agarwal (eds.)",
   "author1": "Mori K",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 2008,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Gene Therapy for Macular Disease",
   "publication": "Macular Surgery 2nd Ed, Quiroz-Mercado, Kerrison, Tano, Alfaro, Liggett, Mieler (eds.)",
   "author1": "Gehlbach PL",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2011,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Introduction to Gene Therapy and Related Techniques for Retinal Disorders and Age-Related Macular Degeneration",
   "publication": "Age-Related Macular Degeneration. 2nd Ed",
   "author1": "Leder HA",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 2014,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retinal Detachment Associated with Subthreshold Retinopathy of Prematurity",
   "publication": "Ocular Surgery News 2001",
   "author1": "Gurdian SJ",
   "author2": "Gehlbach PL",
   "author3": "Hunyor AP",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Editorial",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11587176",
   "image": "",
   "notes": ""
 },
 {
   "title": "Quoted in: Antioxidant found in broccoli and broccoli sprouts protects eye from light damage",
   "publication": "Brassica Press Release",
   "author1": "Gehlbach PL",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2004,
   "category": "Basic",
   "type": "Editorial",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Immune system protein may avert blindness",
   "publication": "Comment published in: St. Louis Post Dispatch. Also appeared in: United Press International, The Olympian (WA), Innovations-Report (Germany), Political Gateway (FL), Macon Telegraph (GA), Grand Forks Herald (ND), San Luis Obispo Tribune (CA), Belleville News-Democrat (IL), Columbus Ledger-Enquirer (GA), Monterey County Herald (CA), Centre Daily Times (PA), Biloxi Sun Herald (MS), Duluth News Tribune (MN), Charlotte Observer (NC), Contra Costa Times (CA), The State (SC), Kansas City Star, Myrtle Beach Sun News (SC), Bradenton Herald (FL), EurekAlert and Kentucky.com",
   "author1": "Gehlbach PL",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2006,
   "category": "Basic",
   "type": "Editorial",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Detection, intervention may positively impact outcomes",
   "publication": "Optometry Times",
   "author1": "Meszaros L",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2010,
   "category": "Basic",
   "type": "Editorial",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Slowing the progression of AMD",
   "publication": "Optometry Times",
   "author1": "Meszaros L",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2011,
   "category": "Basic",
   "type": "Editorial",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Applying an evidenced-based approach to macular disorders",
   "publication": "Optometry Times",
   "author1": "Meszaros L",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2012,
   "category": "Basic",
   "type": "Editorial",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ocriplasmin injection linked to impaired vision",
   "publication": "MedScape News Ophthalmology",
   "author1": "Gehlbach PL",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2014,
   "category": "Basic",
   "type": "Editorial",
   "link": "https://www.medscape.com/viewarticle/821488",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smoking strongly linked to age-related blindness",
   "publication": "Reuters Health",
   "author1": "Gehlbach PL",
   "author2": "",
   "author3": "",
   "moreAuthors": false,
   "date": 2011,
   "category": "Basic",
   "type": "Editorial",
   "link": "https://www.dailytrust.com.ng/weekly/index.php/health-extra/5887-smoking-strongly-linked-to-age-related-blindness",
   "image": "",
   "notes": ""
 },
 {
   "title": "Single fiber optical coherence tomography microsurgical instruments for computer and robot-assisted retinal surgery",
   "publication": "Medical Image Computing and Computer-Assisted Intervention - MICCAI",
   "author1": "Balicki M",
   "author2": "Han J-H",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-04268-3_14",
   "image": "",
   "notes": "Best CAI Paper"
 },
 {
   "title": "Active multispectral illumination and image fusion for retinal microsurgery",
   "publication": "International Conference on Information Processing in Computer Assisted Interventions (IPCAI)",
   "author1": "Sznitman R",
   "author2": "Billings S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://link.springer.com/chapter/10.1007%2F978-3-642-13711-2_2",
   "image": "",
   "notes": ""
 },
 {
   "title": "Unified detection and tracking in retinal microsurgery",
   "publication": "Med Image Comput Comput Assist Interv",
   "author1": "Sznitman R",
   "author2": "Basu A",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-23623-5_1",
   "image": "",
   "notes": "Runner-up for best paper in medical robotics"
 },
 {
   "title": "A free-hand surface tracking and motion compensation microsurgical tool system based on common-path optical coherence tomography distance sensor",
   "publication": "Lasers and Electro-Optics (CLEO) and Quantum Electronics and Laser Science Conference (QELS)",
   "author1": "Zhang K",
   "author2": "Petrillo KG",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/5500195/",
   "image": "",
   "notes": ""
 },
 {
   "title": "A free-hand surface tracking and motion compensation microsurgical tool system based on common-path optical coherence tomography distance sensor",
   "publication": "28th Annual ASRS Meeting",
   "author1": "Gehlbach PL",
   "author2": "Zhang K",
   "author3": "Kang JU",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Adaptive multispectral illumination for retinal microsurgery",
   "publication": "International Conference on Medical Image Computing and Computer Assisted Intervention (MICCAI)",
   "author1": "Sznitman R",
   "author2": "Rother D",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-15711-0_58",
   "image": "",
   "notes": ""
 },
 {
   "title": "Internal limiting membrane layer visualization and vitreoretinal surgery guidance using a common-path OCT integrated microsurgical tool",
   "publication": "Biomedical Optics and Medical Imaging Publications - SPIE",
   "author1": "Liu X",
   "author2": "Meisner E",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.spiedigitallibrary.org/conference-proceedings-of-spie/7550/755003/Internal-limiting-membrane-layer-visualization-and-vitreoretinal-surgery-guidance-using/10.1117/12.840976.short?SSO=1",
   "image": "",
   "notes": ""
 },
 {
   "title": "A common-path optical coherence tomography distance-sensor based surface tracking and motion compensation hand-held microsurgical tool",
   "publication": "SPIE Conference Proceedings 2011",
   "author1": "Zhang K",
   "author2": "Gehlbach PL",
   "author3": "Kang JU",
   "moreAuthors": false,
   "date": 2011,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/5682497/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Recent work toward a microsurgical assistant for retinal surgery",
   "publication": "Hamlyn Symposium on Medical Robotics",
   "author1": "Taylor R",
   "author2": "Kang JU",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Data-driven visual tracking in retinal microsurgery",
   "publication": "Medical Image Computing and Computer-Integrated Interventions (MICCAI)",
   "author1": "Sznitman R",
   "author2": "Richa R",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-33418-4_70",
   "image": "",
   "notes": ""
 },
 {
   "title": "Swept source optical coherence tomography based smart handheld vitreoretinal microsurgical tool for tremor suppression",
   "publication": "Conference Proceedings IEEE Engineering in Medicine and Biology Society",
   "author1": "Song C",
   "author2": "Gehlbach PL",
   "author3": "Kang JU",
   "moreAuthors": false,
   "date": 2012,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3672223/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Force sensing micro-forceps for robot assisted retinal surgery",
   "publication": "Conference Proceedings IEEE Engineering in Medicine and Biology Society",
   "author1": "Kuru I",
   "author2": "Gonenc B",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3957212/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Force sensing micro-forceps with integrated fiber Bragg grating for vitreoretinal surgery",
   "publication": "Progress in Biomedical Optics and Imaging - Proceedings of SPIE Photonics West",
   "author1": "He X",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.spiedigitallibrary.org/conference-proceedings-of-spie/8218/1/Force-sensing-micro-forceps-with-integrated-fiber-Bragg-grating-for/10.1117/12.909602.short",
   "image": "",
   "notes": ""
 },
 {
   "title": "Lecture Notes in Computer Science (including subseries Lecture Notes in Artificial Intelligence and Lecture Notes in Bioinformatics)",
   "publication": "Augmented Environments for Computer-Assisted Interventions – 7th International Workshop, AE-CAI, Held in Conjunction with MICCAI",
   "author1": "Richa R",
   "author2": "Vagvolgyi B",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Lecture Notes in Computer Science (including subseries Lecture Notes in Artificial Intelligence and Lecture Notes in Bioinformatics)",
   "publication": "Augmented Environments for Computer-Assisted Interventions – 7th International Workshop, AE-CAI, Held in Conjunction with MICCAI",
   "author1": "Balicki M",
   "author2": "Richa R",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Toward clinically applicable steady-hand eye robot for vitreoretinal surgery",
   "publication": "ASME International Mechanical Engineering Congress & Exposition (IMECE)",
   "author1": "He X",
   "author2": "Roppenecker D",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://proceedings.asmedigitalcollection.asme.org/proceeding.aspx?articleid=1750369",
   "image": "",
   "notes": ""
 },
 {
   "title": "Toward a sub-millimetric triaxial force sensing instrument with integrated fiber Bragg grating for vitreoretinal surgery",
   "publication": "17th Annual Conference of the Society for Computer-Aided Surgery (ISCAS)",
   "author1": "He X",
   "author2": "Handa J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3965652/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Interactive OCT annotation and visualization for vitreoretinal surgery",
   "publication": "Augmented Environments for Computer-Assisted Interventions. Lecture Notes in Computer Science",
   "author1": "Balicki M",
   "author2": "Richa R",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://link.springer.com/chapter/10.1007/978-3-642-38085-3_14",
   "image": "",
   "notes": ""
 },
 {
   "title": "CP-OCT sensor guided SMART micro-forceps",
   "publication": "Progress in Biomedical Optics and Imaging – Proceedings of SPIE",
   "author1": "Song C",
   "author2": "Gehlbach PL",
   "author3": "Kang JU",
   "moreAuthors": false,
   "date": 2014,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.spiedigitallibrary.org/conference-proceedings-of-spie/8938/1/CP-OCT-sensor-guided-SMART-micro-forceps/10.1117/12.2038391.short",
   "image": "",
   "notes": ""
 },
 {
   "title": "Injection-Depth-Locking Axial Motion Guided Handheld Micro-Injector Using CP-SSOCT",
   "publication": "Conference Proceedings IEEE Engineering in Medicine and Biology Society",
   "author1": "Cheon GW",
   "author2": "Huang Y",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/6945036/",
   "image": "",
   "notes": ""
 },
 {
   "title": "FBG-Based Sensorized Light Pipe for Robotic Intraocular Illumination Facilitates Bimanual Retinal Microsurgery",
   "publication": "37th Annual International Conference of the IEEE Engineering in Medicine and Biology Society of the IEEE Engineering in Medicine and Biology Society in MiCo",
   "author1": "Horise Y",
   "author2": "He X",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/7318249/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Development of the Dual Smart Micro-surgical System using Common-path Swept Source Optical Coherence Tomography",
   "publication": "7th Annual International Conference of the IEEE Engineering in Medicine and Biology Society of the IEEE Engineering in Medicine and Biology Society (EMBC) in MiCo",
   "author1": "Park H-C",
   "author2": "Yeo C",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/7318247/",
   "image": "",
   "notes": ""
 },
 {
   "title": "3-DOF Force Sensing Micro-forceps for Robot-Assisted Membrane Peeling: Intrinsic Actuation Force Modeling",
   "publication": "6th IEEE RAS/EMBS International Conference on Biomedical Robotics and Biomechanatroincs (BioRob)",
   "author1": "Gao A",
   "author2": "Gonenc B",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/7523674/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Active Depth-guiding Handheld Micro-forceps for Membranectomy Based on CP-SSOCT",
   "publication": "SPIE BiOS",
   "author1": "Cheon GW",
   "author2": "Lee P",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "https://www.spiedigitallibrary.org/conference-proceedings-of-spie/9702/1/Active-depth-guiding-handheld-micro-forceps-for-membranectomy-based-on/10.1117/12.2212715.short",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ex vivo study of diffusion of indocyanine green (ICG) in cow retinal layers using optical coherence tomography",
   "publication": "CLEO: Applications and Technology",
   "author1": "Lee C",
   "author2": "Lee S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/8083624/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Evaluation of Optical Coherence Tomography Distal Sensor with High-index Elliptical Cone Epoxy Lens",
   "publication": "CLEO: Applications and Technology",
   "author1": "Lee S",
   "author2": "Lee C",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "http://ieeexplore.ieee.org/document/8083032/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Safe Tissue Manipulation in Retinal Microsurgery via Motorized Instruments with Force Sensing",
   "publication": "IEEE Sensors 2017 Conference",
   "author1": "Gonenc B",
   "author2": "Gehlbach PL",
   "author3": "Taylor R",
   "moreAuthors": true,
   "date": 2017,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://ieeexplore.ieee.org/document/8234070/",
   "image": "",
   "notes": ""
 },
 {
   "title": "Evolution of Vitreoretinal Separation in Normal Subjects as Described By Wide-angle Montage Imaging of Optical Coherence Tomorgraphy",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Tsukahara M",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Initial Proof-of-Concept of Photoacoustic Neural Stimulation; A Potential Approach to Retinal Stimulation: Preliminary In Vitro Study",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Harraz M",
   "author3": "Kang JU",
   "moreAuthors": true,
   "date": 2017,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2642614",
   "image": "",
   "notes": ""
 },
 {
   "title": "Posterior Vitreous Mobility in Eyes with Epiretinal Membrane, Vitreomacular Traction Syndrome and Macular Hole",
   "publication": "Investigative Ophthalmology & Visual Science.",
   "author1": "Mori K",
   "author2": "Tsukahara M",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 2017,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2637653",
   "image": "",
   "notes": ""
 },
 {
   "title": "Development of A Custom Imaging System for Simultaneous Monitoring of Retinal and Cortical Physiology",
   "publication": "Association for Research in Vision and Ophthalmology",
   "author1": "Gehlbach PL",
   "author2": "Boctor E",
   "author3": "",
   "moreAuthors": false,
   "date": 2016,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2557523",
   "image": "",
   "notes": ""
 },
 {
   "title": "Non-Diabetic Ocular Abnormalities Detected by Telemedicine Diabetic Retinopathy Assessment Technology in Safety-Net Medical Clinics",
   "publication": "48th Annual Retina Society Meeting",
   "author1": "Zimmer Galler I",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Noninvasive imaging of retinal blood vessels and blood flow using a custom, non-mydriatic, handheld optical imager designed for use in primary care and telehealth settings",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Rege A",
   "author2": "Raje K",
   "author3": "Kheng M",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2336065",
   "image": "",
   "notes": ""
 },
 {
   "title": "Evaluation of Motion Artifact Associated with Use of a Custom, Handheld Imaging Device for Non-Invasive Retinal Blood Flow (RBF) Measurements in Telehealth Settings",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Brooke MJ",
   "author2": "Cheng TY",
   "author3": "Raje K",
   "moreAuthors": true,
   "date": 2015,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2336073",
   "image": "",
   "notes": ""
 },
 {
   "title": "Optical-Sensor Guided Intelligent Micro-injector for Retinal Therapy",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Gehlbach PL",
   "author2": "Cheon G",
   "author3": "Huang Y",
   "moreAuthors": true,
   "date": 2014,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2266900",
   "image": "",
   "notes": ""
 },
 {
   "title": "New Approaches to Remote Retinal Imaging",
   "publication": "American Telemedicine Association Annual Meeting",
   "author1": "Zimmer-Galler, I",
   "author2": "Reggae, A",
   "author3": "Dakos, A",
   "moreAuthors": true,
   "date": 2014,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Preclinical Assessment of Retinal Vasculature Using a Novel, Non-Invasive, Low-Cost, Mobile Imager",
   "publication": "American Telemedicine Association Annual Meeting",
   "author1": "Zimmer-Galler I",
   "author2": "Rege A",
   "author3": "Dakos A",
   "moreAuthors": true,
   "date": 2014,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Comparison of long-term transduction efficiency of reporter genes after subretinal injection of the adenovirus vectors of serotypes 5, 28, and 35",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Ueyama K",
   "author2": "Mori K",
   "author3": "Hamilton M",
   "moreAuthors": true,
   "date": 2012,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2351909",
   "image": "",
   "notes": ""
 },
 {
   "title": "3-D Image Guided Retinal Surgery Using Real-Time High-Speed Fourier-Domain Optical Coherence Tomography",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Gehlbach PL",
   "author2": "Huang Y",
   "author3": "Zhang K",
   "moreAuthors": true,
   "date": 2012,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2350194",
   "image": "",
   "notes": ""
 },
 {
   "title": "Towards Safer Retinal Microsurgery: Visualization Via Multispectral Illumination",
   "publication": "Extended Abstract in INFORMS Healthcare 2011",
   "author1": "Sznitman R",
   "author2": "Billings S",
   "author3": "Rother D",
   "moreAuthors": true,
   "date": 2011,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Inhibition of angiogenesis by Fc-endostatin.",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Wicks, RJ",
   "author2": "Yoshida J",
   "author3": "Zambrano A",
   "moreAuthors": true,
   "date": 2011,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2362293",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pharmacological inhibition of TGFβ signaling ameliorates disease in a genetic model of axial myopia",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Doyle JJ",
   "author2": "Jun AL",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2369546",
   "image": "",
   "notes": ""
 },
 {
   "title": "Association of the gene variants of compliment factor h and high-temperature requirement a-1 genotypes with response of age-related macular degeneration to photodynamic therapy",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Mori K",
   "author2": "Tsuchihashi T",
   "author3": "Horie-Inoue K",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2369978",
   "image": "",
   "notes": ""
 },
 {
   "title": "A novel force-sensing instrument for vitreoretinal microsurgery",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Sunshine SB",
   "author2": "Iordachita I",
   "author3": "He X",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2372226",
   "image": "",
   "notes": ""
 },
 {
   "title": "Comparison of transduction efficiency and intraocular localization of reporter genes after intravitreal and subretinal injection of the adenovirus vectors of serotypes 5, 28, and 35 with fiber modifications",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Ueyama K",
   "author2": "Mori K",
   "author3": "Hamilton MM",
   "moreAuthors": true,
   "date": 2010,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2373796",
   "image": "",
   "notes": ""
 },
 {
   "title": "An evaluation of potential therapeutic effects of ear cartilage on the inhibition of pathological corneal neovascularization",
   "publication": "WRA Meeting",
   "author1": "Yoshida J",
   "author2": "Stark WJ",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 2010,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular delivery of transforming growth factor beta-1 inhibits developmental eye growth in mice",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Demetriades AM",
   "author2": "Liu H",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2009,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2366229",
   "image": "",
   "notes": ""
 },
 {
   "title": "Demonstration by redox fluorometry that sulforaphane protects retinal pigment epithelial cells against oxidative stress",
   "publication": "IOVS",
   "author1": "Cano M",
   "author2": "Reyes J",
   "author3": "Park CY",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18515589",
   "image": "",
   "notes": ""
 },
 {
   "title": "Strain-related response in the botulinum toxin-induced mouse model of dry eye",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Hongyok T",
   "author2": "Shin YJ",
   "author3": "Na D",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2380714",
   "image": "",
   "notes": ""
 },
 {
   "title": "Peptides derived from type 1 thrombospondin repeat-containing proteins inhibit choroidal neovascularization",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Cano M",
   "author2": "Karagiannis E",
   "author3": "Soliman M",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2379977",
   "image": "",
   "notes": ""
 },
 {
   "title": "In vitro evaluation of predicted antiangiogenic peptides in human retinal endothial cells",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Soliman MS",
   "author2": "Cano MD",
   "author3": "Karagiannis BH",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Peptides derived from thrombospondin type I domain-containing proteins inhibit corneal neovascularization in vivo",
   "publication": "ARVO Meeting Abstract",
   "author1": "Bakir BH",
   "author2": "Cano MD",
   "author3": "Karagiannis ED",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2379978",
   "image": "",
   "notes": ""
 },
 {
   "title": "Functional and structural outcomes of lens removal and insertion of posterior chamber intraocular lenses in patients with Marfan syndrome",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Naimi, EH",
   "author2": "Gehlbach PL",
   "author3": "Maumenee IH",
   "moreAuthors": false,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2376899&resultClick=1",
   "image": "",
   "notes": ""
 },
 {
   "title": "CFH and HTRA1 gene polymorphisms correlate with age-related macular degeneration and polypoidal choroidal vasculopathy but not heterogeneity in their clinical characteristics in a native Japanese population",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Takita H",
   "author2": "Mori K",
   "author3": "Kabasawa S",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2380550",
   "image": "",
   "notes": ""
 },
 {
   "title": "Amniotic Fluid Effects on Corneal Epithelial and Stromal Wound Healing in an ex vivo Organ Culture Model",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Noguera GE",
   "author2": "Castro-Coombs J",
   "author3": "Cano M",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2378792",
   "image": "",
   "notes": ""
 },
 {
   "title": "Age and cigarette smoking, but not gender, moderately influence the risk of amd and pcv in a Japanese population",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Kabasawa S",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2376031",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular triamcinolone enhances intraocular gene expression after delivery by adenovirus",
   "publication": "IOVS",
   "author1": "Park CY",
   "author2": "Chuck RS",
   "author3": "Cano M",
   "moreAuthors": true,
   "date": 2008,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Coding and noncoding variants in the cfh gene and cigarette smoking influence the risk of age-related macular degeneration in a japenese population",
   "publication": "IOVS",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Kabasawa S",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/17962488",
   "image": "",
   "notes": ""
 },
 {
   "title": "Peptides Derived from type 1 thrombospondin repeat-containing proteins of the ccn family inhibit corneal neovascularization",
   "publication": "Vascular Medicine Initiative",
   "author1": "Cano MD",
   "author2": "Karagiannis ED",
   "author3": "Zhuang W",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular triamcinolone enhances intraocular gene expression following delivery by adenovirus",
   "publication": "ASGT Meeting",
   "author1": "Cano M",
   "author2": "Park CY",
   "author3": "Chuck RS",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18172118",
   "image": "",
   "notes": ""
 },
 {
   "title": "β and γ crystallin expression in the developing mouse retina",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Cano MD",
   "author2": "Sinha D",
   "author3": "Zigler JS",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular triamcinolone increases vector traffic to liver following adenovirus mediated ocular gene delivery",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Zhuang W",
   "author2": "Park C",
   "author3": "Cano M",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2387890",
   "image": "",
   "notes": ""
 },
 {
   "title": "Coding and noncoding variants in the cfh gene, including rs1410996, influence the risk of age-related macular degeneration in a Japanese population",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Kabasawa S",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2385596",
   "image": "",
   "notes": ""
 },
 {
   "title": "Corneal reepithelialization is not inhibited following treatment with prevalent viral vectors in an ex vivo model",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Castro Combs JM",
   "author2": "Cano M",
   "author3": "Noguera GE",
   "moreAuthors": true,
   "date": 2007,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2383668",
   "image": "",
   "notes": ""
 },
 {
   "title": "Age-related changes in the rat retinal pigment epithelium/choroid resulting from a beta-crystallin gene mutation",
   "publication": "XII International Symposium on Retinal Degenerations",
   "author1": "Sinha D",
   "author2": "Klise A",
   "author3": "Hose S",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Modulation of voltage-gated potassium channels in dorsal root ganglion neurons by an inducible adenoviral vector in vivo",
   "publication": "ASGT Meeting",
   "author1": "Ma C",
   "author2": "LaMotte RH",
   "author3": "Rosenzweig J",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://www.cell.com/molecular-therapy-family/molecular-therapy/fulltext/S1525-0016(06)01253-6",
   "image": "",
   "notes": ""
 },
 {
   "title": "Studies On the nuc1 spontaneous mutant rat provide novel evidence that lens denucleation occurs by programmed cell death",
   "publication": "US- Japan Meeting cooperative Cataract Research Group",
   "author1": "Cano M",
   "author2": "Gehlbach, P",
   "author3": "Hose S",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Topical human amniotic fluid vs. potent antiangiogenesis protein in the inhibition of induced corneal neovascularization",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Sikder S",
   "author2": "Herretes SP",
   "author3": "Duh E",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Use of topical human amniotic fluid in the treatment of acute alkali burns of the eye",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Pirouzmanesh A",
   "author2": "Herretes SP",
   "author3": "Suwan-Apichon O",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2392559",
   "image": "",
   "notes": ""
 },
 {
   "title": "Sulforaphane inhibits redox fluorometry shifts in retinal pigment epithelium cells following oxidative challenge",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Cano M",
   "author2": "Reyes J",
   "author3": "Chuck RS",
   "moreAuthors": true,
   "date": 2006,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2391939",
   "image": "",
   "notes": ""
 },
 {
   "title": "Eye specific developmental abnormalities in the nuc1 spontaneous mutant rat",
   "publication": "Rat Genomics Models Meeting",
   "author1": "Sinha D",
   "author2": "Hose S",
   "author3": "Cano M",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16289888",
   "image": "",
   "notes": ""
 },
 {
   "title": "Topical human amniotic fluid vs. potent antiangiogenesis protein in the inhibition of induced corneal neovascularization",
   "publication": "AAO",
   "author1": "Herretes S",
   "author2": "Duh E",
   "author3": "Sikder S",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16876508",
   "image": "",
   "notes": ""
 },
 {
   "title": "Use of topical human amniotic fluid in the treatment of acute alkali burns of the eye",
   "publication": "AAO",
   "author1": "Herretes S",
   "author2": "Suwan-apichon O",
   "author3": "Reyes J",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/16876508",
   "image": "",
   "notes": ""
 },
 {
   "title": "Laser photocoagulation and, to the lesser extent, photodynamic therapy target and enhance adenovirus vector-mediated gene transfer in the rat retina",
   "publication": "IOVS",
   "author1": "Anza K",
   "author2": "Yoneya S",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2182425",
   "image": "",
   "notes": ""
 },
 {
   "title": "The nuc1 mutation affects the rat retina and retinal vasculature",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Gehlbach PL",
   "author2": "Cano M",
   "author3": "Hose SL",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2400030",
   "image": "",
   "notes": ""
 },
 {
   "title": "Developmental defects in nuc1 retina affect normal physiological function",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Hose SL",
   "author2": "Zhang C",
   "author3": "Barnstable C",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2400052",
   "image": "",
   "notes": ""
 },
 {
   "title": "Modulation of nuclear factor proteins that control the expression of CIITA by cannabinoids",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Cano M",
   "author2": "Hose SL",
   "author3": "Gongora C",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2401698",
   "image": "",
   "notes": ""
 },
 {
   "title": "Upregulation of lens vegf in a rat model with persistent hyaloid vasculature",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Zigler JS",
   "author2": "Zhang C",
   "author3": "Arora M",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2402343",
   "image": "",
   "notes": ""
 },
 {
   "title": "A possible function of β- and γ-crystallins in vascular remodeling",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Sinha D",
   "author2": "Gongora C",
   "author3": "Zhang C",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Vascular endothelial growth factor gene c-634g polymorphism is associated with age-related macular degeneration",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Kawasaki I",
   "author2": "Yoneya S",
   "author3": "Takata N",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2402443",
   "image": "",
   "notes": ""
 },
 {
   "title": "Optical coherence tomography of enucleated human eye specimens with histological correlation: Evaluation of the origin of the outer “red line” and peripheral retinal pathology",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Ghazi NG",
   "author2": "Dibernardo C",
   "author3": "Ying H",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2402910",
   "image": "",
   "notes": ""
 },
 {
   "title": "Altered expression of aquaporin 1 in a mutant rat with ocular developmental abnormalities",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Arora M",
   "author2": "Gongor C",
   "author3": "Hose SL",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pigment epithelium-derived factor inhibits bfgF-induced corneal neovascularization in mice",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Herretes SP",
   "author2": "Suwan-apichon O",
   "author3": "Reyes JMG",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2403910",
   "image": "",
   "notes": ""
 },
 {
   "title": "An empty e1-, e3-, e4- adenoviral vector ameliorates light-induced photoreceptor degeneration",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Takita H",
   "author2": "Imai D",
   "author3": "Yoneya S",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2404631",
   "image": "",
   "notes": ""
 },
 {
   "title": "Empty e1-, e3-, e4+ and empty e1-, e3-, e4- adenoviral vectors inhibit retinal neovascularization",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Mori K",
   "author2": "Okuda A",
   "author3": "Ito T",
   "moreAuthors": true,
   "date": 2005,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2404630",
   "image": "",
   "notes": ""
 },
 {
   "title": "Evaluation of high-capacity adenovectors for delivery of pedf to the eye",
   "publication": "The Molecular Biology of Tumor Viruses Meeting",
   "author1": "Bruder JT",
   "author2": "Chen P",
   "author3": "Kroeger K",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Persistent pedf expression following intravitreal administration of high-capacity adenovectors",
   "publication": "ASGT Meeting",
   "author1": "Bruder JT",
   "author2": "Chen P",
   "author3": "Kroeger K",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/18827806",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ultrastructural, functional, and transcriptional changes during age induced aging to the rpe-bruch’s membrane-choriocapillaris in the d-galactose treated mouse",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Tian J",
   "author2": "Ishibashi K",
   "author3": "Grebe R",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2406004",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular gene product delivery of pigment epithelium-derived factor induces regression of ocular neovascularization",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Gehlbach PL",
   "author2": "Deering T",
   "author3": "Callahan K",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2405987",
   "image": "",
   "notes": ""
 },
 {
   "title": "Application of native ocular antiangiogenic factor, pedf, for ocular neovascular diseases",
   "publication": "Angiogenesis",
   "author1": "Wei LL",
   "author2": "King CR",
   "author3": "Brough D",
   "moreAuthors": true,
   "date": 2004,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Antiangiogenic gene delivery for retinal and choroidal neovascularization",
   "publication": "Western Eye Research Conference",
   "author1": "Gehlbach PL",
   "author2": "Wei L",
   "author3": "Carrion M",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Watershed zone may or may not exist in the macular choroid in normal human eyes",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Shibuya M",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2412738",
   "image": "",
   "notes": ""
 },
 {
   "title": "Both laser photocoagulation and photodynamic therapy enhance gene transfer in the rat retina mediated by adenoviral vector.",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Anzai K",
   "author2": "Gehlbach PL",
   "author3": "Shibuya M",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2412236",
   "image": "",
   "notes": ""
 },
 {
   "title": "Transscleral delivery of proteins by periocular gene transfer",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Demetriades A-M",
   "author2": "Lu L",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2414135",
   "image": "",
   "notes": ""
 },
 {
   "title": "Increased expression of brain-derived neurotrophic factor preserves retinal function and slows cell death from rhodopsin mutation or oxidative damage",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Okoye GS",
   "author2": "Zimmer J",
   "author3": "Sung J",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2414952",
   "image": "",
   "notes": ""
 },
 {
   "title": "Application of magnetic resonance microimaging to the quantitative assessment of blood-retinal barrier permeability, in transgenic mice",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Yamamoto S",
   "author2": "Artemov D",
   "author3": "Bhujwalla Z",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2415434",
   "image": "",
   "notes": ""
 },
 {
   "title": "Duration of antiangiogenic effect following periocular delivery of ad.pedf.11 in mice with laser-induced choroidal neovascularization (CNV)",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Gehlbach PL",
   "author2": "Deering T",
   "author3": "Yamamoto S",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2415380",
   "image": "",
   "notes": ""
 },
 {
   "title": "Adenoviral-vectored tgf-B1 does not inhibit retinal or choroidal neovascularization",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Callahan KP",
   "author2": "Gehlbach PL",
   "author3": "Demetriades A",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Rescue of light induced photoreceptor cell death by intraocular gene transfer of pigment epithelium-derived factor by reducing retinal cell apoptosis",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Imai D",
   "author2": "Takita H",
   "author3": "Yoneya S",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2415384",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retinal function 10 months after intraocular or periocular injection of aav-cba-pedf",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Deering TG",
   "author2": "Gehlbach PL",
   "author3": "Okoye G",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2415388",
   "image": "",
   "notes": ""
 },
 {
   "title": "Ocular sublocalization and pharmacokinetics of expression of pigment epithelium-derived factor in murine eyes following adenovirus-based intravitreous gene delivery",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Carrion ME",
   "author2": "Hamilton M",
   "author3": "Harris B",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2415389",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular gene transfer of pigment epithelium-derived factor protects the retina from ischemia reperfusion injury by reducing retinal cell apoptosis",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Takita H",
   "author2": "Imai D",
   "author3": "Yoneya S",
   "moreAuthors": true,
   "date": 2003,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2417037",
   "image": "",
   "notes": ""
 },
 {
   "title": "Induction of VEGF expression in neonatal mice results in vascular proliferation in the inner retina",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Deering TG",
   "author2": "Gehlbach PL",
   "author3": "Yamamoto S",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2418569",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular injection of an adenoviral vector expressing the extracellular portion of vascular endothelial growth factor receptor-1 (Adsflt.10) inhibits choroidal neovascularization (CNV)",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Demetriades A-M",
   "author2": "Gehlbach PL",
   "author3": "Yamamoto S",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.researchgate.net/publication/10806533_Periocular_injection_of_an_adenoviral_vector_encoding_pigment_epithelium-derived_factor_inhibits_choroidal_neovascularization",
   "image": "",
   "notes": ""
 },
 {
   "title": "Evaluation of synapse formation at the graft-host interface in transplanted rd mice",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Arai, S-I",
   "author2": "Sadda SR",
   "author3": "Walton CJ",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2420685",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular adenovirus-mediated delivery of pigment epithelium-derived factor Inhibits choroidal neovascularization",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Gehlbach PL",
   "author2": "Yamamoto S",
   "author3": "Demetriades AM",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2421839",
   "image": "",
   "notes": ""
 },
 {
   "title": "Characterization of double transgenic mice with inducible expression of vegf in the retina",
   "publication": "ARVO Meeting Abstracts",
   "author1": "Yamamoto S",
   "author2": "Gehlbach PL",
   "author3": "Xiao W",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2420067",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraocular adenoviral vector-mediated gene transfer in proliferative retinopathies",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Mori K",
   "author2": "Gehlbach PL",
   "author3": "Ando A",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11980881",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pigment epithelium-derived factor suppresses ischemia-induced retinal neovascularization and VEGF-induced migration and growth",
   "publication": "Invest Ophthalmol Vis Sc",
   "author1": "Duh EJ",
   "author2": "Yank HS",
   "author3": "Suzuma I",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11867604",
   "image": "",
   "notes": ""
 },
 {
   "title": "Inducible expression of vascular endothelial growth factor in adult mice causes severe proliferative retinopathy and retinal detachment",
   "publication": "American Journal of Pathology",
   "author1": "Ohno-Matsui K",
   "author2": "Hirose A",
   "author3": "Yamamoto S",
   "moreAuthors": true,
   "date": 2002,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11839592",
   "image": "",
   "notes": ""
 },
 {
   "title": "Clinical Protocol: An open-label, phase I, single administration, dose-escalation study of adgvpedf in neovascular age-related macular degeneration (AMD)",
   "publication": "Human Gene Therapy",
   "author1": "Rasmussen H",
   "author2": "Chu KW",
   "author3": "Campochiaro P",
   "moreAuthors": true,
   "date": 2001,
   "category": "Case Study",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11727737",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retinal detachment associated with subthreshold retinopathy of prematurity",
   "publication": "J Pediatr Ophthalmol Strabismus",
   "author1": "Gurdian SJ",
   "author2": "Gehlbach PL",
   "author3": "Hunyor AP",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11587176",
   "image": "",
   "notes": ""
 },
 {
   "title": "Inhibition of choroidal neovascularization by intravenous injection of adenoviral vectors expressing secretable endostain",
   "publication": "American Journal of Pathology",
   "author1": "Mori K",
   "author2": "Ando A",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11438478",
   "image": "",
   "notes": ""
 },
 {
   "title": "Pigment epithelium-derived factor inhibits retinal and choroidal neovascularization",
   "publication": "Journal of Cellular Physiology",
   "author1": "Mori K",
   "author2": "Duh E",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/11424092",
   "image": "",
   "notes": ""
 },
 {
   "title": "Increased expression of pigment epithelium-derived factor inhibits retinal and choroidal neovascularization",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Mori K",
   "author2": "Duh E",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "In vivo expression of pigment epithelium-derived factor by adenovirus-mediated gene therapy",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Duh E",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Adenovirus mediated reporter gene transfer in normal and pdgf transgenic mice",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Mori K",
   "author3": "Ando A",
   "moreAuthors": true,
   "date": 2001,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Self-induced yawning stimulates aqueous tear production",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Rooney SM",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2000,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Comparison of binocular vs. monocular interpretation of fluorescein angiograms in neovascular age related macular degeneration",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Hiner CJ",
   "author3": "Klein ML",
   "moreAuthors": false,
   "date": 1999,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Surgical treatment of choroidal neovascular membranes associated with angioid streaks",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Thomas MA",
   "author3": "",
   "moreAuthors": false,
   "date": 1997,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.researchgate.net/publication/317755989_Surgical_treatment_of_choroidal_neovascular_membranes_associated_with_angioid_streaks",
   "image": "",
   "notes": ""
 },
 {
   "title": "Subretinal endolaser photocoagulation of a recurrent juxtafoveal neovascular membrane in presumed ocular histoplasmosis syndrome",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Thomas MA",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 1997,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.researchgate.net/publication/317756123_Subretinal_endolaser_photocoagulation_'of_a_recurrent_juxtafoveal_neovascular_membrane_in_presumed_ocular_histoplasmosis_syndrome",
   "image": "",
   "notes": ""
 },
 {
   "title": "Developmental expression of NMDA receptor subunits and NMDA-mediated toxicity in rat retina",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Izumi Y",
   "author3": "Olney JW",
   "moreAuthors": true,
   "date": 1996,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Deferoxamine inhibits asphyxia-induced increases in leukocyte adherence and vascular permeability",
   "publication": "Society for Neuroscience",
   "author1": "Park TS",
   "author2": "Beetsch JW",
   "author3": "Gonzales AR",
   "moreAuthors": true,
   "date": 1996,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Comparison of two different synthetic oxygen carriers in the isolated perfused eye of the cat",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Anderson ML",
   "author2": "Gehlbach PL",
   "author3": "Purple RL",
   "moreAuthors": false,
   "date": 1995,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Retinal toxicity of the iron chelator 1, 2-dimethyl-3-hydroxypyrid-4-one, (L1), in an albino rat model",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Schauer BA",
   "author2": "Purple RL",
   "author3": "Gehlbach PL",
   "moreAuthors": false,
   "date": 1995,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Enhancement of retinal recovery by conjugated deferoxamine after ischemia-reperfusion",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Purple RL",
   "author3": "",
   "moreAuthors": false,
   "date": 1994,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/7509327",
   "image": "",
   "notes": ""
 },
 {
   "title": "Conjugated deferoxamine enhances recovery following ischemia and reperfusion injury in the cat retina",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Purple RL",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "A paired comparison of post ischemic recovery in two models of experimental retinal ischemia",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Purple RL",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Basic",
   "type": "Abstract",
   "link": "https://www.tandfonline.com/doi/abs/10.3109/02713689408999893",
   "image": "",
   "notes": ""
 },
 {
   "title": "Conjugated deferoxamine reduces deferoxamine induced retinal toxicity in an albino rat model",
   "publication": "Investigative Ophthalmology & Visual Science",
   "author1": "Gehlbach PL",
   "author2": "Schultz LM",
   "author3": "Purple RL",
   "moreAuthors": true,
   "date": 1992,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Enhancement of guinea pig duodenal motor activity by application of a \"gastrointestinal chemical-pacemaker\"",
   "publication": "American College of Surgeons Meeting, The Surgical Forum",
   "author1": "Gehlbach PL",
   "author2": "Hoey M",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "The use of tobramycin impregnated polymethyl-methacrylate beads in treating vascular prosthetic material infections: an animal model",
   "publication": "Annual University of Vermont Surgical Research Forum",
   "author1": "Gehlbach PL",
   "author2": "Hebert JC",
   "author3": "Pilcher D",
   "moreAuthors": false,
   "date": 1986,
   "category": "Basic",
   "type": "Abstract",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (USA)",
   "publication": "Application No. 07987748. Publication No. 5383873",
   "author1": "Hoey M",
   "author2": "Gehlbach GL",
   "author3": "",
   "moreAuthors": false,
   "date": 1992,
   "category": "Basic",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (USA)",
   "publication": "Application No. 94905347. Publication No. 0673242",
   "author1": "Hoey M",
   "author2": "Gehlbach GL",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Basic",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (USA)",
   "publication": "Application No. 2151055. Publication No. 2151055",
   "author1": "Hoey M",
   "author2": "Gehlbach GL",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Basic",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (USA)",
   "publication": "Application No. 07987748. Patent No. 5383873",
   "author1": "Gehlbach GL",
   "author2": "Hoey M",
   "author3": "",
   "moreAuthors": false,
   "date": 1995,
   "category": "Basic",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Multifunctional Neck Brace (USA)",
   "publication": "Application No. 11798041. Publication No. 20080004556",
   "author1": "Gehlbach GL",
   "author2": "Cortes HM",
   "author3": "Davenport MS",
   "moreAuthors": true,
   "date": 2008,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Use of Crystallin for the Modulation of Angiogenesis (USA)",
   "publication": "Application No. 12309026.  Publication No. 20100004168",
   "author1": "Gehlbach GL",
   "author2": "Sinha D",
   "author3": "Hose S",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual Tracking and Annotation of Clinically Important Anatomical Landmarks for Surgical Interventions (USA)",
   "publication": "Application No. 10827611. Publication No. 2493387",
   "author1": "Balicki MA",
   "author2": "Taylor RH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Selective Induction of Apoptosis to Treat Ocular Disease by Expression of PEDF (USA)",
   "publication": "Application No. 11938562. Publication No. 20080132464",
   "author1": "Campachiaro PA",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback (USA)",
   "publication": "Application No. 11815199. Publication No. 2600813",
   "author1": "Taylor RH",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micro-Force Guided Cooperative Control for Manipulation of Delicate Tissue (USA)",
   "publication": "Application No. 11815201. Publication No. 2600789",
   "author1": "Taylor RH",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Surface Tracking and Motion Compensation Surgical Tool System (USA)",
   "publication": "Application No. 11810348. Publication No. 2595586",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "Taylor RH",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Surgical Instrument with Integrated Optical Sensor (USA)",
   "publication": "Application No. 12917168. Publication No. 20110106102",
   "author1": "Balicki MA",
   "author2": "Taylor RH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual tracking and annotation of clinically important anatomical landmarks for surgical interventions (USA)",
   "publication": "Application No. 13505058. Publication No.2011053921",
   "author1": "Taylor RH",
   "author2": "Taylor RH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2012,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Surface Tracking and Motion Compensating Surgical Tool System (USA)",
   "publication": "Application No. 13811077. Publication No. 20130123759",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "Taylor RH",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micro-force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue (USA)",
   "publication": "Application No. 13813738. Publication No. 20130304258",
   "author1": "Taylor RH",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2013,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Distal Sensor Controlled Drug Injector (USA)",
   "publication": "Application No. 14163491. Publication No. 20150209527",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2014,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback (USA)",
   "publication": "Application No. 13813727. Publication No. 20140052150",
   "author1": "Taylor RH",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micromanipulation Systems and Methods (USA)",
   "publication": "Application No. 14810277. Publication No. 20160030240",
   "author1": "Gonenc B",
   "author2": "Iordachita I",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Distal Sensor Controlled Drug Injector (USA)",
   "publication": "Application No. 14163491. Publication No. 20150209527",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "High-efficiency illumination system (USA)",
   "publication": "Application No. 13642436. Patent No. 9116262",
   "author1": "Kang JU",
   "author2": "Billings SD",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Distal Sensor Controlled Micro-Manipulation Systems and Methods (USA)",
   "publication": "Application No. 14256695. Publication No. 20150297404",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Motion-Compensated Micro-Forceps System and Methods (USA)",
   "publication": "Application No. 14261264. Publication No. 20150305761",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2016,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Programmable Multispectral Illumination System for Surgery and Visualization of Light-Sensitive Tissues (USA)",
   "publication": "Application No. 13387950. Patent No. 9320428",
   "author1": "Taylor RH",
   "author2": "Billings SD",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2016,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (Europe)",
   "publication": "European Patent Application Number 94905347.4",
   "author1": "Hoey M",
   "author2": "Gehlbach GL",
   "author3": "",
   "moreAuthors": false,
   "date": 1992,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (Australia)",
   "publication": "Australian Patent Number 685420",
   "author1": "Hoey M",
   "author2": "Gehlbach GL",
   "author3": "",
   "moreAuthors": false,
   "date": 1998,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Smooth Muscle Chemical Pacemaker (International)",
   "publication": "Publication No. WO/1994/013269. International Application No. PCT/US1993/011928",
   "author1": "Hoey M",
   "author2": "Gehlbach GL",
   "author3": "",
   "moreAuthors": false,
   "date": 1993,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Use of Crystallin for the Modulation of Angiogenesis (International)",
   "publication": "Publication No. WO/2008/005021. International Application No. PCT/US2006/026450",
   "author1": "Gehlbach PL",
   "author2": " Sinha D",
   "author3": "Cano M",
   "moreAuthors": true,
   "date": 2006,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Programmable Multispectral Illumination System for Surgery and Visualization of Light-Sensitive Tissues (International)",
   "publication": "Publication No. WO/2011/017550. International Application No. PCT/US2010/044596",
   "author1": "Taylor RH",
   "author2": "Billings SD",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual Tracking and Annotation of Clinically Important Anatomical Landmarks for Surgical Interventions (International)",
   "publication": "Publication No. WO/2011/053921. International Application No. PCT/US2010/054988",
   "author1": "Balicki MA",
   "author2": "Taylor RH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "High Efficiency Illumination System",
   "publication": "Publication No. WO/2012/011988. International Application No. PCT/US2011/033236",
   "author1": "Kang JU",
   "author2": "Billings SD",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Surface Tracking and Motion Compensating Surgical Tool System",
   "publication": "Publication No. WO/2012/012540. International Application No. PCT/US2011/044693",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "Taylor RH",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback",
   "publication": "Publication No. WO/2012/018821. International Application No. PCT/US2011/046276",
   "author1": "Taylor RH",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micro-Force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue",
   "publication": "Publication No. WO/2012/018823. International Application No. PCT/US2011/046278",
   "author1": "Taylor RH",
   "author2": "Balicki MA",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Compact High Efficient Multispectral LED Endoscopic Illumination System",
   "publication": "International Application No. C10970",
   "author1": "Kang JU",
   "author2": "Billings SD",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2014,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Periocular Gene Transfer For Retinal and Choroidal Diseases",
   "publication": "International Application No. C03994",
   "author1": "Gehlbach PL",
   "author2": "Campochiaro P",
   "author3": "",
   "moreAuthors": false,
   "date": 2014,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Distal Sensor Controlled Micro-Manipulation Systems and Methods",
   "publication": "Publication No. WO/2015/161101. International Application No. PCT/US2015/026211",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Motion-Compensated Micro-Forceps System and Method",
   "publication": "Publication No. WO/2015/164216. International Application No. PCT/US2015/026506",
   "author1": "Kang JU",
   "author2": "Gehlbach PL",
   "author3": "",
   "moreAuthors": false,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "1-D Surface Tracking and Motion Compensation Hand-held Microsurgical Tool System Based on Dynamic Common-Path Optical Coherence Tomography Sensor Value Proposition",
   "publication": "International Application No.C11161. PCT/US2011/044693",
   "author1": "Balicki MA",
   "author2": "Taylor RH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micro-force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue",
   "publication": "International Application No. C11172",
   "author1": "Handa J",
   "author2": "Taylor RH",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot and Audio Feedback",
   "publication": "International Application No. C11167",
   "author1": "Balicki MA",
   "author2": "Gehlbach PL",
   "author3": "Uneri A",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Surgical Instrument with Integrated Forward Looking Optical Coherence Tomography",
   "publication": "International Application No. C10900",
   "author1": "Handa J",
   "author2": "Gehlbach PL",
   "author3": "Taylor RH",
   "moreAuthors": true,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual Tracking and Annotation of Clinically Important Anatomical Landmarks for Surgical Interventions (China)",
   "publication": "File Number, P10899-03, Patent Issued Number, 201080060214.8",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual Tracking and Annotation of Clinically Important Anatomical Landmarks for Surgical Interventions (Europe)",
   "publication": "File Number, P10899-04, Patent Issued Number, 10827611.4",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual Tracking and Annotation of Clinically Important Anatomical Landmarks for Surgical Interventions (Japan)",
   "publication": "ile Number, P10899-05, Patent Issued Number, 2012-537171",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Visual Tracking and Annotation of Clinically Important Anatomical Landmarks for Surgical Interventions (Republic of Korea)",
   "publication": "File Number, P10899-06, Patent Issued Number, 10-2012-7013988",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2010,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "1-D Surface Tracking and Motion Compensation Hand-held Microsurgical Tool System Based on Dynamic Common-Path Optical Coherence Tomography Sensor (China)",
   "publication": "File Number, P11161-04, Patent Issued Number, 201180035450.9",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "1-D Surface Tracking and Motion Compensation Hand-held Microsurgical Tool System Based on Dynamic Common-Path Optical Coherence Tomography Sensor (Europe)",
   "publication": "File Number, P11161-05, Patent Issued Number, 11810348.0",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "1-D Surface Tracking and Motion Compensation Hand-held Microsurgical Tool System Based on Dynamic Common-Path Optical Coherence Tomography Sensor (Japan)",
   "publication": "File Number, P11161-06, Patent Issued Number, 2013-520839",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "1-D Surface Tracking and Motion Compensation Hand-held Microsurgical Tool System Based on Dynamic Common-Path Optical Coherence Tomography Sensor (Republic of Korea)",
   "publication": "File Number, P11161-07, Patent Issued Number 10-2013-7003643",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback (China)",
   "publication": "File Number, P11167-04, Patent Issued Number 201180038449.1",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback (Europe)",
   "publication": "File Number, P11167-05, Patent Issued Number 11815199.2",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback (Japan)",
   "publication": "File Number, P11167-06, Patent Issued Number 2013-5232752013523275",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Method for Presenting Force Sensor Information Using Cooperative Robot Control and Audio Feedback (Republic of Korea)",
   "publication": "File Number, P11167-07, Patent Issued Number 10-2013-7003049",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "Micro-force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue (China)",
   "publication": "File Number, P11172-04, Patent Issued Number 201180037143.4",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "Micro-force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue (Europe)",
   "publication": "File Number, P11172-05, Patent Issued Number 11815201.6",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micro-force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue  (Japan)",
   "publication": "File Number, P11172-06, Patent Issued Number, 2013-523276",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Micro-force Guided Cooperative Control for Surgical Manipulation of Delicate Tissue (Republic of Korea)",
   "publication": "File Number, P11172-07, Patent Issued Number, 10-2013-700314210-2013-7003142",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2011,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "Retina and Anterior Segment Imaging System for Use in Contaminated and Resource-poor Settings (\"The Ebola-scope\")",
   "publication": "P13530-01",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Implantable Lens Capsule for Intraocular Lens Insertion",
   "publication": "P14721-01",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2017,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Miniature Dexterous Manipulator for Therapeutic and Diagnostic Procedures In the Clinical Setting Where Tool Access Is Limited",
   "publication": "P13480-01",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Sensor Integrated Micro-forceps",
   "publication": "P12631-01",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2013,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Distal Sensor Controlled Drug Injector",
   "publication": "P12746-01",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2013,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Fiber Optic Distal Sensor Controlled Surgical Blade",
   "publication": "P12835-01",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2013,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Force-sensing Motorized Micro-forceps and Method of Use in Microsurgery",
   "publication": "P13009-02",
   "author1": "",
   "author2": "",
   "author3": "",
   "moreAuthors": null,
   "date": 2015,
   "category": "Engineering",
   "type": "Patent",
   "link": "",
   "image": "",
   "notes": "Pending"
 },
 {
   "title": "Towards Robot-Assisted Retinal Vein Cannulation: A Motorized Force-Sensing Microneedle Integrated with a Handheld Micromanipulator",
   "publication": "Sensors (Basel)",
   "author1": "Gonenc B",
   "author2": "Chae J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/28946634",
   "image": "",
   "notes": ""
 },
 {
   "title": "3-DOF Force-Sensing Motorized Micro-Forceps for Robot-Assisted Vitreoretinal Surgery.",
   "publication": "IEEE Xplore: IEEE Sensors Journal",
   "author1": "Gonenc B",
   "author2": "Chamani A",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/28946634",
   "image": "",
   "notes": ""
 },
 {
   "title": "Robot-Assisted Vitreoretinal Surgery: Current Perspectives (+ Video abstract)",
   "publication": "Robotic Surgery: Research and Reviews ",
   "author1": "Roizenblatt M",
   "author2": "Edwards T",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5842029/",
   "image": "",
   "notes": ""
 },
 {
   "title": "A Potential Role for Statins in Age-Related Macular Degeneration",
   "publication": "Seminars in Ophthalmology",
   "author1": "Roizenblatt M",
   "author2": "Naranjit N",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Basic",
   "type": "Original Research",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Real-Time Sclera Force Feedback for Enabling Safe Robot-Assisted Vitreoretinal Surgery",
   "publication": "40th International Engineering in Medicine and Biology Conference (EMBC) 2018. ",
   "author1": "Ebrahimii A",
   "author2": "He C",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Proceeding Report",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Clinical Challenges in Age Related Macular Degeneration",
   "publication": "Insight: The Journal of the American Society of Ophthalmic Registered Nurses",
   "author1": "Roizenblatt M",
   "author2": "Jiramongkolchai K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Original Research",
   "link": "https://library.rangercollege.edu/eds/detail?db=cin20&an=127134719&isbn=1060135X",
   "image": "",
   "notes": ""
 },
 {
   "title": "Intraretinal Injection: Fiber Optics OCT Sensor Guided SMART Micro-injector Enables Precise Intraretinal Injections in Bovine Eyes",
   "publication": "ARVO",
   "author1": "Kang J",
   "author2": "Chae J",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2017,
   "category": "Engineering",
   "type": "Abstract",
   "link": "http://iovs.arvojournals.org/article.aspx?articleid=2637378",
   "image": "",
   "notes": ""
 },
 {
   "title": "Antiangiogenic Gene Therapy: Prospects for Human Application",
   "publication": "Vitreoretinal Surgical Techniques: Principles and Practice; Peyman GA (ed.)",
   "author1": "Gehlbach PL",
   "author2": "Roizenblatt M",
   "author3": "Mori K",
   "moreAuthors": false,
   "date": 2017,
   "category": "Basic",
   "type": "Book Chapter",
   "link": "",
   "image": "",
   "notes": ""
 },
 {
   "title": "Natural History of Posterior Vitreous Detachment - An Observational Cross-Sectional Study with Wide-Angle Montaged Optical Coherence Tomography Imaging",
   "publication": "Ophthalmology ",
   "author1": "Tsukahara M",
   "author2": "Mori K",
   "author3": "Gehlbach PL",
   "moreAuthors": true,
   "date": 2018,
   "category": "Basic",
   "type": "Original Research",
   "link": "https://www.ncbi.nlm.nih.gov/pubmed/26349565",
   "image": "",
   "notes": ""
 }
]



// WEBPACK FOOTER //
// ./src/data.js